module.exports = __webpack_public_path__ + "img/post_3.1eb6c3af.jpg";